<template>
  <section class="page-hero">
    <article class="page-hero__panel">
      <span class="label page-hero__eyebrow">{{ eyebrow }}</span>
      <h1 class="page-hero__title">{{ title }}</h1>
      <p class="page-hero__lede">
        {{ lede }}
        <strong v-if="typeof ledeEmphasis === 'string'" class="page-hero__lede-emphasis">
          {{ ledeEmphasis }}
        </strong>
        <strong
          v-else-if="Array.isArray(ledeEmphasis) && ledeEmphasis.length"
          class="page-hero__lede-emphasis"
        >
          <span
            v-for="line in ledeEmphasis"
            :key="line"
            class="page-hero__lede-emphasis-line"
          >
            {{ line }}
          </span>
        </strong>
      </p>
      <p v-if="note" class="page-hero__note">{{ note }}</p>

      <div class="page-hero__actions">
        <router-link
          v-for="action in actions"
          :key="action.label"
          :to="action.to"
          class="button page-hero__action"
          :class="action.primary ? 'button--primary' : 'button--ghost'"
        >
          {{ action.label }}
        </router-link>
      </div>
    </article>

    <aside class="page-hero__aside">
      <div class="page-hero__aside-mark">
        <div>
          <h2 class="page-hero__aside-title">{{ aside.title }}</h2>
          <p>{{ aside.copy }}</p>
        </div>
      </div>

      <div
        v-for="block in aside.blocks"
        :key="block.label"
        class="page-hero__aside-block"
      >
        <span class="label">{{ block.label }}</span>
        <p v-if="block.text">{{ block.text }}</p>
        <ul v-if="block.items" class="page-hero__list">
          <li v-for="item in block.items" :key="item">{{ item }}</li>
        </ul>
        <router-link
          v-if="block.action"
          :to="block.action.to"
          class="button page-hero__action page-hero__block-action"
          :class="block.action.primary ? 'button--primary' : 'button--ghost'"
        >
          {{ block.action.label }}
        </router-link>
      </div>
    </aside>
  </section>
</template>

<script setup>
defineProps({
  eyebrow: String,
  title: String,
  lede: String,
  ledeEmphasis: {
    type: [String, Array],
    default: '',
  },
  note: String,
  actions: Array,
  aside: Object,
})
</script>
